import React from 'react';
import {Link, Typography} from '@mui/material';

const CoverageFintelLink = ({reportId, reportTitle, onNavigate, variant = 'caption'}) => {
    const label = reportTitle || reportId;
    if (!reportId || !label) {
        return null;
    }

    return (
        <Link
            component="button"
            variant={variant}
            onClick={(e) => {
                e.stopPropagation();
                onNavigate?.(reportId);
            }}
            sx={{
                flex: 1,
                minWidth: 0,
                textAlign: 'left',
                fontWeight: 700,
                color: 'text.primary',
                cursor: 'pointer',
                '&:hover': {color: 'primary.main', textDecoration: 'underline'},
            }}
        >
            <Typography component="span" variant={variant} color="inherit" fontWeight="inherit">
                {label}
            </Typography>
        </Link>
    );
};

export default CoverageFintelLink;
